import { RiskEntity, OpportunityEntity, PositiveImpactEntity, NegativeImpactEntity } from 'dmui_components'

export const ENTITY = {
	risk: RiskEntity,
	opportunity: OpportunityEntity,
	positive_impact: PositiveImpactEntity,
	negative_impact: NegativeImpactEntity
}

export const DEFAULT_IRO_STATS = {
	risk: 0,
	opportunity: 0,
	positive_impact: 0,
	negative_impact: 0
}

export const VALUE_STREAMS_MAPPING = {
	core_operations: 'Core operations',
	upstream: 'Upstream',
	downstream: 'Downstream'
}
